import React, { createContext, useContext, useState } from "react";
import { API_URL } from "../utils/apiUrl";

const AuthContext = createContext(null);

// Lets non-React code (the api client) trigger logout
let externalLogout = null;

// Plain fetch, not the api client: a 401 here must not re-trigger forceLogout.
export function notifyLogout() {
  const token = localStorage.getItem("inv_panel_token");
  if (!token) return;
  fetch(`${API_URL}/logout`, {
    method: "POST",
    headers: { Token: token },
    keepalive: true,
  }).catch(() => {});
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("inv_panel_user")) || null;
    } catch {
      return null;
    }
  });

  function login(userData) {
    setUser(userData);
    localStorage.setItem("inv_panel_user", JSON.stringify(userData));
  }

  function logout() {
    notifyLogout();
    setUser(null);
    localStorage.removeItem("inv_panel_user");
    localStorage.removeItem("inv_panel_token");
  }

  externalLogout = logout;

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

// A SUPERADMIN sees everything; an ADMIN sees only their own channels and
// plans, and not the change history or the Users page (the API enforces it)
export const SUPERADMIN = "SUPERADMIN";
export const isSuperAdmin = (user) => user?.role === SUPERADMIN;

export function useAuth() {
  return useContext(AuthContext);
}

export function forceLogout() {
  if (externalLogout) {
    externalLogout();
  }
  window.location.href = "/login";
}
